import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "./App.css";
import AutoExpandingTextArea from "./Components/AutoExpandingTextArea.tsx";

interface AIRoomInstructionsProps {
  roomName: string;
  sessionId: string;
  socket: any;
  initialValue: string;
  onDone: () => void;
  onBack: () => void;
}

function AIRoomInstructions({
  roomName,
  sessionId,
  socket,
  initialValue,
  onDone,
  onBack,
}: AIRoomInstructionsProps) {
  const { t } = useTranslation();
  const [input, setInput] = useState(initialValue);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  // Saved on blur as well as on NESTE, like the pre-rework free-text step.
  const save = () => {
    socket.emit("ai room set instructions", {
      roomName,
      sessionId,
      customInstructions: input,
    });
  };

  const submit = () => {
    save();
    socket.emit("ai room owner setup done", { roomName, sessionId });
    onDone();
  };

  return (
    <div className="App-header">
      <div className="container-row lift-topbar">
        <div className="container-row-start">
          <div
            className="button-tertiary-m button-text-m text-color-black"
            onClick={() => {
              save();
              onBack();
            }}
            style={{ maxHeight: "32.5px" }}
          >
            {t("back")}
          </div>
        </div>
        <div className="text-h3 text-color-black left-margin-s text-force-break">
          {roomName}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
          width: "100%",
        }}
      >
        <p
          className="text-h2 text-color-black"
          style={{ marginTop: 32, marginBottom: 24 }}
        >
          {t("ai.instructions.title")}
        </p>

        <AutoExpandingTextArea
          value={input}
          onChange={setInput}
          textareaRef={textAreaRef}
          placeholder={t("write-here")}
          maxLength={1000}
          onBlur={save}
        />
      </div>

      <div
        className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
        onClick={submit}
      >
        {t("next")}
      </div>
    </div>
  );
}

export default AIRoomInstructions;
